import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/images/manus_fortis_3_soloLogoTransparente.png";

const HeroSection = () => {
    return (
        <section style={{}}>
            <Container className="container-hero my-7 d-flex flex-column align-items-center" style={{ height: '85vh' }}>
                <img src={logo} alt="Logo Manus Fortis" className="logo-hero" style={{ height: '140px' }} />
                <h1 className="h1-hero text-center">
                    MANUS FORTIS
                </h1>
                <div
                // style={{ display: 'flex', justifyContent: 'space-between', width: '700px' }}
                >
                    <p className="p-hero">
                        Quiromasaje
                    </p>

                    {/* <p className="p-hero">
                        Entrenamiento personal
                    </p> */}
                </div>
                <Link className="btn btn-hero" to="/cita">
                    Pide tu cita
                </Link>
            </Container>
        </section>
    );
};

export default HeroSection;